import React from 'react';
import { connect } from 'react-redux';
import { Alert,Col } from 'reactstrap';
import User from './User';
import './UsersList.css';
import SortIcons from './ProposalsSortIcons';
import utils from '../lib/utils';

const UsersList = ({
  users = [],
  disabledUser,
  onDelete,
  onSetStatus,
  user,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            {
              utils.filterCustomer(user?.role) ? (
                <th className="cursor-pointer" onClick={() => onSort('_id')}>
                  ID <SortIcons sortObj={sortValue} sortName="_id" />
                </th>
              ) : null
            }
            <th className="cursor-pointer" onClick={() => onSort('companyName')}>
              Company Name <SortIcons sortObj={sortValue} sortName="companyName" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('email')}>
              Email <SortIcons sortObj={sortValue} sortName="email" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('name')}>
              Name <SortIcons sortObj={sortValue} sortName="name" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('role')}>
              Role <SortIcons sortObj={sortValue} sortName="role" />
            </th>
            <th>Status</th>
            <th>2FA</th>
            <th className="cursor-pointer" onClick={() => onSort('registerDate')}>
              Created On <SortIcons sortObj={sortValue} sortName="registerDate" />
            </th>
            <th>Last Activity</th>
            {
              utils.filterCustomer(user?.role) ? (
                (user.role === 'admin' ||
                  user.role === 'enterpriseAdmin' ||
                  user.role === 'superAdmin' ||
                  user.role === 'companyGroupAdmin' ||
                  user.role === 'companyGroupManager' ||
                  user.role === 'supportEngineer') && <th colSpan="1">Actions</th>) : null}
          </tr>
        </thead>
        <tbody>
          {users && users.length ? (
            users.map(userObj => (
              <User
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={userObj._id}
                user={userObj}
                onDelete={onDelete}
                onSetStatus={onSetStatus}
                userRole={user.role}
                loggedInUser={user}
              // disabled={userObj._id === disabledUser}
              />
            ))
          ) : (
            <tr>
              <td colSpan={9}>
                <Alert rowSpan={9} color="info">
                  No Users Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(UsersList);
